module.exports = __webpack_public_path__ + "media/img/loading-621cc8ad.gif";